import { Component, OnInit } from "@angular/core";
import { WindowScrollController } from "@fullcalendar/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { LoginService } from "src/app/login/login.service";
import { DataDownload, DataDownloadRecord } from "src/app/models/am-data-download";
import { DownloadService } from "../../services/download.service";

@Component({
    selector: "app-datadownload",
    templateUrl: "./datadownload.component.html",
    styleUrls: ["./datadownload.component.scss"],
})
export class DatadownloadComponent implements OnInit {
    dataDownloads$: Observable<DataDownload[]>;
    constructor(
        private downloadService: DownloadService,
        private loginService: LoginService
    ) {}


    ngOnInit(): void {
        this.dataDownloads$ = this.downloadService.getAll()
        .pipe(
            map((data) => {
                return data.map(x=>{ return {...x, Title: this.makeTitle(x)};});
            })
        );
    }

    protected groupAndMapDataDownloads(data: DataDownload[]): DataDownloadRecord {
        let dataDownloads: DataDownloadRecord = {};
        data.forEach((d) => {
            if (dataDownloads[d.Title] == null) {
                dataDownloads[d.Title] = [];
            }
            dataDownloads[d.Title].push(d);
        });
        
        return dataDownloads;
    }


    public doDownload(str)
    {
        window.location.href="/Download/GetDataFile?filename="+encodeURI(str);
    }

    private makeTitle( d:DataDownload): string{
/*  ALL=1,
    EN=1,
    DE=2,
    FR=3,
    IT=4,
    ES=5,
    NL=6*/
        let lang='';
        switch(d.CatLanguageId){
            case 0: lang = 'ALL';break;
            case 1: lang = 'English';break;
            case 2: lang = 'Deutsch';break;
            case 3: lang = 'Français';break;
            case 4: lang = 'Italiano';break;
            case 5: lang = 'Español';break;
            case 6: lang = 'Nederlands';break;
        }

        var freq="";
        switch(d.Freq.trim().toUpperCase()){
            case 'D': freq = 'Daily';break;
            case 'M': freq = 'Monthly';break;
            case 'Y': freq = 'Yearly';break;
        }
        return freq+ ' Data : '+lang;

    }
}
